import { AnalyticsService } from './analytics.service';
import axios from 'axios';
import * as $ from 'jquery';
var FormsService = /** @class */ (function () {
    function FormsService() {
        this.gRecaptchaSiteKey = "6LfBLFMqAAAAALclWnjdSuQ_nJTcLq_lDnsA7AQ6";
        // powerCurve errors
        this.powerCurveErrors = [
            {
                'error': 'Credit Decline 1',
                'message': 'DD04_Score Decline',
                'code': 'DD04'
            },
            {
                'error': 'Decline 1',
                'message': 'DA58_No Bureau Consent_PS',
                'code': 'DA58'
            },
            {
                'error': 'Decline 2',
                'message': 'DA60_Under Admin Order_PS',
                'code': 'DA60'
            },
            {
                'error': 'Decline 3',
                'message': 'DA61_Under Sequestration_PS',
                'code': 'DA61'
            },
            {
                'error': 'Decline 4',
                'message': 'DA57_No Terms & Conditions_PS',
                'code': 'DA57'
            },
            {
                'error': 'Decline 5',
                'message': 'DA53_Under Debt Review',
                'code': 'DA53'
            },
            {
                'error': 'Decline 6',
                'message': 'DH67_Capture an RCP',
                'code': 'DH67'
            },
            {
                'error': 'Decline 7',
                'message': 'DA59_Customer Has No Surplus',
                'code': 'DA59'
            },
            {
                'error': 'Decline 8',
                'message': 'DD02_Adverse Status',
                'code': 'DD02'
            },
            {
                'error': 'Decline 9',
                'message': 'DR15_ID Warning',
                'code': 'DR15'
            },
            {
                'error': 'Decline 10',
                'message': 'DS47_No Bureau Information',
                'code': 'DS47'
            },
            {
                'error': 'Decline 11',
                'message': 'DA97_Bureau Debt Review',
                'code': 'DA97'
            },
            {
                'error': 'Decline 12',
                'message': 'DS43_Bureau Admin Order',
                'code': 'DS43'
            },
            {
                'error': 'Decline 13',
                'message': 'DD38_Reduction order on file',
                'code': 'DD38'
            },
            {
                'error': 'Decline 14',
                'message': 'DA18_Number of Dishonours L6M > 12',
                'code': 'DA18'
            },
            {
                'error': 'Decline 15',
                'message': 'DA19_Significant Days in Excess L6M > 60',
                'code': 'DA19'
            },
            {
                'error': 'Decline 16',
                'message': 'DD07_Bureau Not Clean',
                'code': 'DD07'
            },
            {
                'error': 'Decline 17',
                'message': 'DR38_Bureau Installments Exceeds Income',
                'code': 'DR38'
            },
            {
                'error': 'Decline 18',
                'message': 'DA36_Existing SBSA Loan on Record',
                'code': 'DA36'
            },
            {
                'error': 'Decline 19',
                'message': 'DD24_MasterCard Delinquent',
                'code': 'DD24'
            },
            {
                'error': 'Decline 20',
                'message': 'DD31_VAF Delinquent L6M',
                'code': 'DD31'
            },
            {
                'error': 'Decline 21',
                'message': 'DD30_Home Loan Delinquent',
                'code': 'DD30'
            },
            {
                'error': 'Decline 22',
                'message': 'DD39_WTP or ABIL Loan in Customer Profile',
                'code': 'DD39'
            },
            {
                'error': 'Decline 23',
                'message': 'DR32_Customer is part time employed',
                'code': 'DR32'
            },
            {
                'error': 'Decline 24',
                'message': 'DR58_Verification of Salary Required',
                'code': 'DR58'
            },
            {
                'error': 'Decline 25',
                'message': 'DA15_Customer is under 18',
                'code': 'DA15'
            },
            {
                'error': 'Decline 26',
                'message': 'DS16_Age > 65',
                'code': 'DS16'
            },
            {
                'error': 'Decline 27',
                'message': 'DA08_No Identification Given',
                'code': 'DA08'
            },
            {
                'error': 'Decline 28',
                'message': 'RA91_Advance Acnt Exposure - Refer to Credit',
                'code': 'RA91'
            },
            {
                'error': 'Decline 29',
                'message': 'RA92_Student Loan Exposure - Refer to Credit',
                'code': 'RA92'
            },
            {
                'error': 'Decline 30',
                'message': 'DR27_Foreign National',
                'code': 'DR27'
            },
            {
                'error': 'Decline 31',
                'message': 'RA14_Sefl Employed MTL',
                'code': 'RA14'
            },
            {
                'error': 'Decline 32',
                'message': 'RA96_Refer to Credit for Confirmation',
                'code': 'RA96'
            },
            {
                'error': 'Decline 33',
                'message': 'DR33_Customer employment status is unknown',
                'code': 'DR33'
            },
            {
                'error': 'Decline 34',
                'message': 'DA14_Non Resident',
                'code': 'DA14'
            },
            {
                'error': 'Decline 35',
                'message': 'DP19_One Account in Customer Profile',
                'code': 'DP19'
            },
            {
                'error': 'Decline 36',
                'message': 'DS49_Maximum Reprocess Allowed',
                'code': 'DS49'
            },
            {
                'error': 'Decline 37',
                'message': 'DS21_Low Income Loan Recently Granted',
                'code': 'DS21'
            },
            {
                'error': 'Decline 38',
                'message': 'DP95_LIUL Arrears',
                'code': 'DP95'
            },
            {
                'error': 'Decline 39',
                'message': 'DE42_Existing Loans is in arrears',
                'code': 'DE42'
            },
            {
                'error': 'Decline 40',
                'message': 'SD27_NLR Enquiry Last 1 Year',
                'code': 'SD27'
            },
            {
                'error': 'Decline 26',
                'message': 'DS18_Occupation Status not met',
                'code': 'DS18'
            },
            {
                'error': 'Decline 20',
                'message': 'DA38_GMI < 3000',
                'code': 'DA38'
            },
            {
                'error': 'Decline 21',
                'message': 'DD06_Self Employed',
                'code': 'DD06'
            },
            {
                'error': 'Decline 15',
                'message': 'DS09_Total Value of Judgments',
                'code': 'DS09'
            },
            {
                'error': 'Decline 13',
                'message': 'DS22_SAPPL Adverse Status',
                'code': 'DS22'
            },
            {
                'error': 'Decline 11',
                'message': 'DS23_Insufficient payment profile on Bureau',
                'code': 'DS23'
            },
            {
                'error': 'Refer 2',
                'message': 'RR40_Requested Limit < Current Outstanding Balance',
                'code': 'RR40'
            },
            {
                'error': 'Refer 3',
                'message': 'RA48_Age of Customer > 65',
                'code': 'RA48'
            },
            {
                'error': 'Decline 30',
                'message': 'DD25_Unpaid Credits L6m',
                'code': 'DD25'
            },
            {
                'error': 'Decline 31',
                'message': 'DS51_Missing Expenses',
                'code': 'DS51'
            },
            {
                'error': 'Decline 27',
                'message': 'DD23_Age of account < 6 months',
                'code': 'DD23'
            },
            {
                'error': 'Decline 28',
                'message': 'DD22_Recent limit increase',
                'code': 'DD22'
            },
            {
                'error': 'Decline 23',
                'message': 'DD37_Product not Permitted',
                'code': 'DD37'
            },
            {
                'error': 'Decline 6',
                'message': 'DA25_PL GMI < 6001 AND GMI < 8001',
                'code': 'DA25'
            },
            {
                'error': 'Decline 11',
                'message': 'DA35_Existing RCP',
                'code': 'DA35'
            },
            {
                'error': 'Decline 13',
                'message': 'DS40_Existing Loan',
                'code': 'DS40'
            },
            {
                'error': 'Decline 16',
                'message': 'DR60_Existing Advanced Account',
                'code': 'DR60'
            }
        ];
    }
    FormsService.getInstance = function () {
        if (!FormsService.instance) {
            FormsService.instance = new FormsService();
        }
        return FormsService.instance;
    };
    FormsService.prototype.postForm = function (url, fields, config) {
        if (config === void 0) { config = null; }
        var analyticsService = new AnalyticsService();
        if (!config) {
            config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    'Access-Control-Allow-Origin': '*',
                    'X-Requested-With': 'XMLHttpRequest',
                    'Analytics-User': analyticsService.getDtmVisitorID()
                }
            };
        }
        var results = axios.post(url, fields, config).then(function (response) {
            // service ok
            return response;
        }).catch(function (response) {
            // service failed
            return response;
        });
        return results;
    };
    FormsService.prototype.serializeForm = function (form) {
        /*!
        * Serialize all form data into a query string
        * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
        * @param  {Node}   form The form to serialize
        * @return {String}      The serialized form data
        */
        // Setup our serialized data
        var serialized = [];
        // Loop through each field in the form
        for (var i = 0; i < form.elements.length; i++) {
            var field = form.elements[i];
            // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
            if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') {
                continue;
            }
            // If a multi-select, get all selections
            if (field.type === 'select-multiple') {
                for (var n = 0; n < field.options.length; n++) {
                    if (!field.options[n].selected) {
                        continue;
                    }
                    serialized.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.options[n].value));
                }
            }
            else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
                // Convert field data to a query string
                serialized.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value));
            }
        }
        return serialized.join('&');
    };
    FormsService.prototype.detect = function (form, loader, thankyou) {
        switch (form.id) {
            case 'apply-now-submit_application':
                this.SubmitApplicationForm(form, loader, thankyou);
                break;
            case 'apply-now-submit_application_business':
                this.SubmitApplicationFormBusiness(form, loader, thankyou);
                break;
            case 'call-me-back-submit_application_need_help':
                this.SubmitNeedHelpForm(form, loader, thankyou);
                break;
            case 'apply-now-submit_application_insurance':
                this.SubmitApplicationFormInsurance(form, loader, thankyou);
                break;
            case 'apply-now-submit_application_access_quote':
                this.SubmitApplicationFormAccessQuote(form, loader, thankyou);
                break;
            case 'apply-now-submit_application_access_quote_pc':
                this.SubmitApplicationFormAccessQuotePc(form, loader, thankyou);
                break;
            case 'apply-now-submit_application_mail':
                this.SubmitApplicationFormMail(form, loader, thankyou);
                break;
            default:
                break;
        }
    };
    FormsService.prototype.getGRecaptchaSiteKey = function () {
        return this.gRecaptchaSiteKey;
    };
    FormsService.prototype.SubmitApplicationForm = function (form, loader, thankyou) {
        // fields
        var description = form.querySelector('input[name=description]');
        var firstname = form.querySelector('input[name=first-name]');
        var lastname = form.querySelector('input[name=last-name]');
        var contact = form.querySelector('input[name=phone-number]');
        var contact2 = form.querySelector('input[name=phone-number-2]');
        var idnumber = form.querySelector('input[name=identification]');
        var email = form.querySelector('input[name=email]');
        var date = form.querySelector('input[name=date]');
        var time = form.querySelector('select[name=time]');
        var fullname = firstname.value + ' ' + lastname.value;
        // loader + hide form
        var fieldsContainer = form.querySelector('.form__fields--container');
        loader.classList.add('active');
        fieldsContainer.classList.add('hidden');
        // variables
        var analyticsService = new AnalyticsService();
        var url = '/services/SubmitApplicationForm.jsp';
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        var postData = '';
        if (description) {
            postData += 'description=' + description.value;
        }
        if (firstname && lastname) {
            postData += '&fullName=' + fullname;
        }
        if (contact) {
            postData += '&contact=' + contact.value;
        }
        if (contact2) {
            postData += '&contact2=' + contact2.value;
        }
        if (idnumber) {
            postData += '&idNum=' + idnumber.value;
        }
        if (email) {
            postData += '&email=' + email.value;
        }
        if (date) {
            if (time) {
                if (time.value !== 'Anytime') {
                    postData += '&timeToCall=' + date.value + ' ' + time.value;
                }
                else {
                    postData += '&timeToCall=anytime';
                }
            }
            else {
                postData += '&timeToCall=anytime';
            }
        }
        postData += '&source=' + this.isMobile();
        // service
        axios.post(url, postData, config).then(function (response) {
            // service ok
            loader.classList.remove('active');
            if (response.data === 'invalid') {
                analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
                loader.classList.remove('active');
                fieldsContainer.classList.remove('hidden');
            }
            else {
                analyticsService.dtmFormComplete('complete', response.data);
                loader.classList.remove('active');
                thankyou.classList.add('active');
            }
        }).catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            loader.classList.remove('active');
            fieldsContainer.classList.remove('hidden');
        });
    };
    FormsService.prototype.SubmitApplicationFormBusiness = function (form, loader, thankyou) {
        // fields
        var enquiryType = form.querySelector('select[name=enquiry-type]');
        if (enquiryType && (enquiryType.value === 'Enquiry')) {
            // fields
            var emailAddress = form.querySelector('input[name=email-address]');
            var recipient = form.querySelector('input[name=recipient]');
            var subject = form.querySelector('input[name=subject]');
            var description = form.querySelector('input[name=description]');
            var firstname = form.querySelector('input[name=first-name]');
            var lastname = form.querySelector('input[name=last-name]');
            var phoneNumber = form.querySelector('input[name=phone-number]');
            var altPhoneNumber = form.querySelector('input[name=alternative-number]');
            var email = form.querySelector('input[name=email]');
            // loader + hide form
            var fieldsContainer = form.querySelector('.form__fields--container');
            loader.classList.add('active');
            fieldsContainer.classList.add('hidden');
            // variables
            var analyticsService_1 = new AnalyticsService();
            var url = '/services/SubmitGenericForm.jsp';
            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    'Access-Control-Allow-Origin': '*',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            };
            var postData = '';
            if (emailAddress) {
                postData += 'email=' + emailAddress.value;
            }
            if (recipient) {
                postData += '&recipient=' + recipient.value;
            }
            if (subject) {
                postData += '&subject=' + subject.value;
            }
            if (description) {
                postData += '&description=' + description.value;
            }
            if (firstname) {
                postData += '&firstname=' + firstname.value;
            }
            if (lastname) {
                postData += '&surname=' + lastname.value;
            }
            if (phoneNumber) {
                postData += '&contactNo=' + phoneNumber.value;
            }
            if (altPhoneNumber) {
                postData += '&AltContactNo=' + altPhoneNumber.value;
            }
            if (email) {
                postData += '&email-address=' + email.value;
            }
            var _documents = thankyou.querySelector('.form__thankyou--documents');
            if (_documents) {
                _documents.style.display = 'none';
            }
            // service
            axios.post(url, postData, config).then(function (response) {
                // service ok
                loader.classList.remove('active');
                analyticsService_1.dtmFormComplete('complete', '');
                loader.classList.remove('active');
                thankyou.classList.add('active');
            }).catch(function (response) {
                // service failed
                analyticsService_1.dtmFormComplete('complete', '');
                loader.classList.remove('active');
                thankyou.classList.add('active');
            });
        }
        else {
            var description = form.querySelector('input[name=description]');
            var firstname = form.querySelector('input[name=first-name]');
            var lastname = form.querySelector('input[name=last-name]');
            var businessType = form.querySelector('select[name=business-type]');
            var businessTypeValue = businessType.options[businessType.selectedIndex].value;
            var businessName = form.querySelector('input[name=business-name]');
            var phoneNumber = form.querySelector('input[name=phone-number]');
            var altPhoneNumber = form.querySelector('input[name=alternative-number]');
            var email = form.querySelector('input[name=email]');
            var businessRegNumber = form.querySelector('input[name=business-reg-number]');
            var idnumber = form.querySelector('input[name=id-number]');
            var existingCustomer = form.querySelector('input[name=existing-customer]');
            // loader + hide form
            var fieldsContainer_1 = form.querySelector('.form__fields--container');
            loader.classList.add('active');
            fieldsContainer_1.classList.add('hidden');
            // variables
            var analyticsService_2 = new AnalyticsService();
            var url_1 = '/services/SubmitApplicationFormBizBankV1.jsp';
            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    'Access-Control-Allow-Origin': '*',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            };
            var postData = '';
            if (description) {
                postData += 'description=' + description.value;
            }
            if (firstname) {
                postData += '&firstname=' + firstname.value;
            }
            if (lastname) {
                postData += '&surname=' + lastname.value;
            }
            if (businessTypeValue) {
                postData += '&businessType=' + businessTypeValue;
            }
            if (businessName) {
                postData += '&businessName=' + businessName.value;
            }
            if (phoneNumber) {
                postData += '&contactNo=' + phoneNumber.value;
            }
            if (altPhoneNumber) {
                postData += '&AltContactNo=' + altPhoneNumber.value;
            }
            if (email) {
                postData += '&email=' + email.value;
            }
            if (businessRegNumber) {
                postData += '&businessRegNumber=' + businessRegNumber.value;
            }
            if (idnumber) {
                postData += '&idNumber=' + idnumber.value;
            }
            if (existingCustomer) {
                if (existingCustomer.checked) {
                    postData += '&isExistingCustomer=YES';
                }
                else {
                    postData += '&isExistingCustomer=NO';
                }
            }
            postData += '&source=' + this.isMobile();
            // service
            axios.post(url_1, postData, config).then(function (response) {
                // service ok
                loader.classList.remove('active');
                if (response.data === 'invalid') {
                    analyticsService_2.dtmRecordSiteError('noerrorcode|invalid fields|' + url_1);
                    loader.classList.remove('active');
                    fieldsContainer_1.classList.remove('hidden');
                }
                else {
                    analyticsService_2.dtmFormComplete('complete', response.data);
                    loader.classList.remove('active');
                    thankyou.classList.add('active');
                    var _documents = thankyou.querySelector('.form__thankyou--documents');
                    if (_documents) {
                        _documents.removeAttribute('style');
                        var _buttonContainer = _documents.querySelector('.form__thank--documents-button');
                        var _subject = 'My Reference Number Is: ' + response.data;
                        var _body = 'To Whom It May Concern\n\nAttached please find a copy of the following documents as requested:\n\nID of owners and signatories\nProof of address not older than 3 months\nCompany registration documents if a registered company';
                        var _mailToText = 'mailto:SmallEnterpriseSales@standardbank.co.za?subject=' + encodeURIComponent(_subject) + '&body=' + encodeURIComponent(_body);
                        var _newButton = document.createElement('a');
                        _newButton.classList.add('button', 'button--large', 'button--centered', 'button--main');
                        _newButton.setAttribute('data-id', 'link_content_ documents email click');
                        _newButton.setAttribute('data-text', 'email documents button click');
                        _newButton.setAttribute('href', _mailToText);
                        var _text = document.createTextNode('EMAIL DOCUMENTS');
                        _newButton.appendChild(_text);
                        _buttonContainer.innerHTML = '';
                        _buttonContainer.appendChild(_newButton);
                    }
                }
            }).catch(function (response) {
                // service failed
                analyticsService_2.dtmRecordSiteError('noerrorcode|service failure occured|' + url_1);
                loader.classList.remove('active');
                fieldsContainer_1.classList.remove('hidden');
            });
        }
    };
    FormsService.prototype.SubmitNeedHelpForm = function (form, loader, thankyou) {
        // fields
        var firstName = form.querySelector('input[name=first-name]');
        var lastName = form.querySelector('input[name=last-name]');
        var contactNumber = form.querySelector('input[name=phone-number]');
        var emailNeedHelp = form.querySelector('input[name=email]');
        var idNumber = form.querySelector('input[name=identification]');
        var senderEmail = form.querySelector('input[name=sender-email]');
        var popiConsent = form.querySelector('input[name=popia-consent]');
        // loader + hide form
        var fieldsContainer = form.querySelector('.form__fields--container');
        loader.classList.add('active');
        fieldsContainer.classList.add('hidden');
        // variables
        var analyticsService = new AnalyticsService();
        var url = '/services/SubmitNeedHelpForm.jsp';
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        var postData = '';
        if (firstName) {
            postData += 'firstName=' + firstName.value;
        }
        if (lastName) {
            postData += '&lastName=' + lastName.value;
        }
        if (contactNumber) {
            postData += '&contactNumber=' + contactNumber.value;
        }
        if (emailNeedHelp) {
            postData += '&email=' + emailNeedHelp.value;
        }
        if (senderEmail) {
            postData += '&senderEmail=' + senderEmail.value;
        }
        if (idNumber) {
            postData += '&idNumber=' + idNumber.value;
        }
        if (popiConsent) {
            postData += '&popiConsent=' + (popiConsent.checked ? "YES" : "NO");
        }
        postData += '&source=' + window.location.href;
        postData += '&sbUseragent=' + this.isMobile();
        // service
        axios.post(url, postData, config).then(function (response) {
            // service ok
            if (response.data === 'invalid') {
                analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
                loader.classList.remove('active');
                fieldsContainer.classList.remove('hidden');
            }
            else {
                analyticsService.dtmFormComplete('complete', response.data);
                loader.classList.remove('active');
                thankyou.classList.add('active');
            }
        }).catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            loader.classList.remove('active');
            fieldsContainer.classList.remove('hidden');
        });
    };
    FormsService.prototype.SubmitApplicationFormInsurance = function (form, loader, thankyou) {
        // fields
        var firstname = form.querySelector('input[name=first-name]');
        var lastname = form.querySelector('input[name=last-name]');
        var contact = form.querySelector('input[name=phone-number]');
        var emailAddress = form.querySelector('input[name=email-address]');
        var productTypeSelect = form.querySelector('select[name=product-type]');
        var productTypeHidden = form.querySelector('input[name=product-type-hidden]');
        // loader + hide form
        var fieldsContainer = form.querySelector('.form__fields--container');
        loader.classList.add('active');
        fieldsContainer.classList.add('hidden');
        // variables
        var analyticsService = new AnalyticsService();
        var url = '/services/SBIS_Handler_COZA.jsp';
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        var postData = '';
        if (firstname) {
            postData += 'first=' + firstname.value;
        }
        if (lastname) {
            postData += '&last=' + lastname.value;
        }
        if (contact) {
            postData += '&cell=' + contact.value;
        }
        if (emailAddress) {
            postData += '&emailAddress=' + emailAddress.value;
        }
        if (productTypeSelect) {
            postData += '&product=' + productTypeSelect.value;
        }
        else {
            if (productTypeHidden) {
                postData += '&product=' + productTypeHidden.value;
            }
        }
        postData += '&source=' + this.isMobile();
        // service
        axios.post(url, postData, config).then(function (response) {
            // service ok
            loader.classList.remove('active');
            if (response.data === 'invalid') {
                analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
                loader.classList.remove('active');
                fieldsContainer.classList.remove('hidden');
            }
            else {
                analyticsService.dtmFormComplete('complete', response.data);
                loader.classList.remove('active');
                thankyou.classList.add('active');
            }
        }).catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            loader.classList.remove('active');
            fieldsContainer.classList.remove('hidden');
        });
    };
    FormsService.prototype.SubmitApplicationFormAccessQuote = function (form, loader, thankyou) {
        // additional containers
        var declined = form.querySelector('.form__declined--container');
        var success = form.querySelector('.form__success--container');
        var value = form.querySelector('.output-value');
        var name = form.querySelector('.form__success-container__firstname');
        // fields
        var description = form.querySelector('input[name=description]');
        var firstName = form.querySelector('input[name=first-name]');
        var lastName = form.querySelector('input[name=last-name]');
        var contact = form.querySelector('input[name=phone-number]');
        var contact2 = form.querySelector('input[name=phone-number-2]');
        var gross = form.querySelector('input[name=gross]');
        var idNum = form.querySelector('input[name=identification]');
        var email = form.querySelector('input[name=email]');
        var date = form.querySelector('input[name=date]');
        var time = form.querySelector('select[name=time]');
        // loader + hide form
        var fieldsContainer = form.querySelector('.form__fields--container');
        loader.classList.add('active');
        fieldsContainer.classList.add('hidden');
        // variables
        var analyticsService = new AnalyticsService();
        var url = '/services/SubmitApplicationFormAQ.jsp';
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        var postData = '';
        if (description) {
            postData += 'description=' + description.value;
        }
        if (firstName) {
            postData += '&firstName=' + firstName.value;
        }
        if (lastName) {
            postData += '&lastName=' + lastName.value;
        }
        if (contact) {
            postData += '&contact=' + contact.value;
        }
        if (contact2) {
            postData += '&contact2=' + contact2.value;
        }
        if (gross) {
            postData += '&gross=' + gross.value;
        }
        if (idNum) {
            postData += '&idNum=' + idNum.value;
        }
        if (email) {
            postData += '&email=' + email.value;
        }
        if (date) {
            if (time) {
                if (time.value !== 'Anytime') {
                    postData += '&timeToCall=' + date.value + ' ' + time.value;
                }
                else {
                    postData += '&timeToCall=anytime';
                }
            }
            else {
                postData += '&timeToCall=anytime';
            }
        }
        postData += '&source=' + this.isMobile();
        // service
        axios.post(url, postData, config).then(function (response) {
            var data = response.data;
            // service ok
            loader.classList.remove('active');
            if (data.validity) {
                if (data.aqResult === 'approve') {
                    analyticsService.dtmFormComplete('complete', data.leadID);
                    thankyou.classList.add('active');
                    declined.classList.remove('active');
                    success.classList.add('active');
                    name.innerHTML = firstName.value;
                    value.innerHTML = 'R' + data.amount;
                }
                else {
                    analyticsService.dtmFormComplete('complete', 'DCE9999999999');
                    analyticsService.dtmRecordSiteError('Access Quote Declined');
                    thankyou.classList.add('active');
                    success.classList.remove('active');
                    declined.classList.add('active');
                }
            }
            else {
                analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
                thankyou.classList.add('active');
                success.classList.remove('active');
                declined.classList.add('active');
            }
        }).catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            loader.classList.remove('active');
            fieldsContainer.classList.remove('hidden');
        });
    };
    FormsService.prototype.SubmitApplicationFormAccessQuotePc = function (form, loader, thankyou) {
        // additional containers
        var declined = form.querySelector('.form__declined--container');
        var success = form.querySelector('.form__success--container');
        var error = form.querySelector('.form__error--container');
        var value = form.querySelector('.output-value');
        var name = form.querySelector('.form__success-container__firstname');
        var qualifiedAmount = form.querySelector('.form__success-container__approvedamount');
        // fields
        var description = form.querySelector('input[name=description]');
        var firstName = form.querySelector('input[name=first-name]');
        var lastName = form.querySelector('input[name=last-name]');
        var contact = form.querySelector('input[name=phone-number]');
        var contact2 = form.querySelector('input[name=phone-number-2]');
        var gross = form.querySelector('input[name=gross]');
        var monthlyexpenses = form.querySelector('input[name=monthlyexpenses]');
        var idNum = form.querySelector('input[name=identification]');
        var email = form.querySelector('input[name=email]');
        var date = form.querySelector('input[name=date]');
        var time = form.querySelector('select[name=time]');
        // loader + hide form
        var fieldsContainer = form.querySelector('.form__fields--container');
        loader.classList.add('active');
        fieldsContainer.classList.add('hidden');
        // variables
        var analyticsService = new AnalyticsService();
        var url = '/services/SubmitApplicationFormPC.jsp';
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        var postData = '';
        if (description) {
            postData += 'description=' + description.value;
        }
        if (firstName) {
            postData += '&firstName=' + firstName.value;
        }
        if (lastName) {
            postData += '&lastName=' + lastName.value;
        }
        if (contact) {
            postData += '&contact=' + contact.value;
        }
        if (contact2) {
            postData += '&contact2=' + contact2.value;
        }
        if (gross) {
            postData += '&gross=' + gross.value;
        }
        if (monthlyexpenses) {
            postData += '&monthlyexpenses=' + monthlyexpenses.value;
        }
        if (idNum) {
            postData += '&idNum=' + idNum.value;
        }
        if (email) {
            postData += '&email=' + email.value;
        }
        if (date) {
            if (time) {
                if (time.value !== 'Anytime') {
                    postData += '&timeToCall=' + date.value + ' ' + time.value;
                }
                else {
                    postData += '&timeToCall=anytime';
                }
            }
            else {
                postData += '&timeToCall=anytime';
            }
        }
        postData += '&source=' + this.isMobile();
        // service
        axios.post(url, postData, config).then(function (response) {
            var data = response.data;
            // service ok
            loader.classList.remove('active');
            if (!data.error && (data.amount || data.code)) {
                if (data.amount) {
                    analyticsService.dtmFormComplete('complete', data.leadID);
                    thankyou.classList.add('active');
                    declined.classList.remove('active');
                    error.classList.remove('active');
                    success.classList.add('active');
                    name.innerHTML = firstName.value;
                    value.innerHTML = 'R' + data.amount;
                    qualifiedAmount.innerHTML = data.amount;
                }
                else {
                    analyticsService.dtmFormComplete('complete', data.code);
                    var _tmp = this.powerCurveErrors.find(function (item) {
                        return item.code = data.code;
                    });
                    if (_tmp) {
                        analyticsService.dtmRecordSiteError(_tmp.message);
                    }
                    else {
                        analyticsService.dtmRecordSiteError('Access Quote Declined');
                    }
                    thankyou.classList.add('active');
                    success.classList.remove('active');
                    error.classList.remove('active');
                    declined.classList.add('active');
                }
            }
            else {
                analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
                thankyou.classList.add('active');
                success.classList.remove('active');
                declined.classList.remove('active');
                error.classList.add('active');
            }
        }).catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            loader.classList.remove('active');
            fieldsContainer.classList.remove('hidden');
        });
    };
    FormsService.prototype.SubmitApplicationFormMail = function (form, loader, thankyou) {
        // fields
        var fields = $(form).serialize();
        // loader + hide form
        var fieldsContainer = form.querySelector('.form__fields--container');
        loader.classList.add('active');
        fieldsContainer.classList.add('hidden');
        // variables
        var analyticsService = new AnalyticsService();
        var url = '/services/SubmitGenericForm.jsp';
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        axios.post(url, fields, config).then(function (response) {
            // service ok
            loader.classList.remove('active');
            analyticsService.dtmFormComplete('complete', '');
            loader.classList.remove('active');
            thankyou.classList.add('active');
        }).catch(function (response) {
            // service failed
            analyticsService.dtmFormComplete('complete', '');
            loader.classList.remove('active');
            thankyou.classList.add('active');
        });
    };
    FormsService.prototype.isMobile = function () {
        var isMobile = (/Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/).test(navigator.userAgent.toLowerCase());
        if (isMobile) {
            return 'MOB';
        }
        else {
            return 'WEB';
        }
    };
    return FormsService;
}());
export { FormsService };



//////////////////
// WEBPACK FOOTER
// ./services/forms.service.ts
// module id = 25
// module chunks = 0